export const isObject = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  
  export const escapeRegexCharacters = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  export const passwordValidation = (password, retype_password) => {
    if (password != retype_password) {
      return "Password Does Not Match"
    } else {
      return ''
    }
  }